import { faFolders } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { type DossFormalitiesAndDocsType } from './OrderDuplicateForm';

type OrderTitleAccordionProps = {
    dossierFormalitiesAndDocs: DossFormalitiesAndDocsType;
};

const OrderTitleAccordion: React.FunctionComponent<OrderTitleAccordionProps> = function ({
    dossierFormalitiesAndDocs,
}) {
    const { palette } = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
            }}
        >
            <FontAwesomeIcon
                icon={faFolders}
                style={{
                    color: palette.grey[600],
                    fontSize: '24px',
                }}
            />
            {dossierFormalitiesAndDocs.dossierNumero && (
                <Typography variant="l2dbodys">
                    {`#${dossierFormalitiesAndDocs.dossierNumero}` as string}
                </Typography>
            )}

            {dossierFormalitiesAndDocs.dossierSiren && (
                <Typography
                    variant="l2dcaption"
                    sx={{ color: 'text.gris70' }}
                >
                    {`Siren: ${dossierFormalitiesAndDocs.dossierSiren}` as string}
                </Typography>
            )}
            {dossierFormalitiesAndDocs.societeRef && (
                <Typography
                    variant="l2dcaption"
                    sx={{ color: 'text.gris70' }}
                >
                    {`Référence client: ${dossierFormalitiesAndDocs.societeRef}` as string}
                </Typography>
            )}
        </Box>
    );
};

export default OrderTitleAccordion;
